import React, { Component } from 'react'

import VerifiedUserStatus from './VerifiedUserStats.js';
import styles from "./stylesheets/RegisteredUserStats.module.css";
import ChainCircle, { RightArrow, RefreshLogo, Tick } from '../Svg/index';
export class RegisteredUserStats extends Component {

    constructor(props) {
        super(props);
        this.state = {
            isUserRegistered: true,
            referrals: 24,
            verifiedReferrals: 20,
            tokensEarned: 142,
            tokensHeld: 41,
            verifiedAddressesList: [                
            '0x837216a0c5f64317db126f52fd152a7e9ed537d1', '0x837216a0c5f64317db126f52fd152a7e9ed537d1', 
            '0x837216a0c5f64317db126f52fd152a7e9ed537d1', '0x837216a0c5f64317db126f52fd152a7e9ed537d1',
            '0x837216a0c5f64317db126f52fd152a7e9ed537d1', '0x837216a0c5f64317db126f52fd152a7e9ed537d1',
            '0x837216a0c5f64317db126f52fd152a7e9ed537d1', '0x837216a0c5f64317db126f52fd152a7e9ed537d1', 
            '0x837216a0c5f64317db126f52fd152a7e9ed537d1', '0x837216a0c5f64317db126f52fd152a7e9ed537d1',
            '0x837216a0c5f64317db126f52fd152a7e9ed537d1', '0x837216a0c5f64317db126f52fd152a7e9ed537d1',
            '0x837216a0c5f64317db126f52fd152a7e9ed537d1', '0x837216a0c5f64317db126f52fd152a7e9ed537d1', 
            '0x837216a0c5f64317db126f52fd152a7e9ed537d1', '0x837216a0c5f64317db126f52fd152a7e9ed537d1',
            '0x837216a0c5f64317db126f52fd152a7e9ed537d1', '0x837216a0c5f64317db126f52fd152a7e9ed537d1',
            '0x837216a0c5f64317db126f52fd152a7e9ed537d1', '0x837216a0c5f64317db126f52fd152a7e9ed537d1', 
            '0x837216a0c5f64317db126f52fd152a7e9ed537d1', '0x837216a0c5f64317db126f52fd152a7e9ed537d1',
            '0x837216a0c5f64317db126f52fd152a7e9ed537d1', '0x837216a0c5f64317db126f52fd152a7e9ed537d1' 
            ]
        }
    }

    render() {
        return (
            <div className={styles.registeredUserStats}>
                <div className={styles.registeredUserStatsHeader}>
                    <VerifiedUserStatus isUserRegistered={this.state.isUserRegistered}></VerifiedUserStatus>
                </div>
                <div className={styles.registeredUserStatsS1}>

                    <div className={styles.holdTokens}>
                        <div className={styles.noOfTokens}>
                            {
                                this.state.tokensHeld
                            }
                        </div>
                        <div className={styles.tokensHeldPara}>
                            <p>Tokens Held</p>
                        </div>
                    </div>
                </div>
                <div className={styles.registeredUserStatsS2}>
                    <div className={styles.referralsTokens}>

                        <div className={styles.referrals}>
                            <p>
                                REFERRELS
                        </p>
                            <div className={styles.value}>
                                {
                                    this.state.referrals
                                }
                            </div>
                        </div>
                        <div className={styles.verifiedReferrals}>
                            <p>
                                VERIFIED REFERRELS
                        </p>
                            <div className={styles.value}>
                                {
                                    this.state.verifiedReferrals
                                }
                            </div>
                        </div>
                        <div className={styles.tokensEarned}>
                            <p>
                                TOKENS EARNED
                        </p>
                            <div className={styles.value}>
                                {
                                    this.state.tokensEarned
                                }
                            </div>
                        </div>
                    </div>
                </div>
                <div className={styles.registeredUserStatsS3}>
                    <div className={styles.registeredAddresses}>
                        <p className={styles.para}>REFERRALS</p>
                        <div className={styles.listOfReferralAddresses}>
                            {
                                this.state.verifiedAddressesList.map((address, index)=>(
                                    <div className={styles.addressesContainer}>
                                        <p>
                                        {
                                            address
                                        }
                                        <span className={styles.tickIcon}>
                                            <Tick></Tick>
                                        </span>
                                        </p>
                                    </div>
                                ))
                            }
                        </div>
                    </div>
                </div>
            </div>
        )
    }
}






export default RegisteredUserStats
